async function cartDiscountUpdate() {
  // ✅ localStorage에서 직접 가져오기 (DOM 의존성 제거)
  let customerId = localStorage.getItem('shopifyId');
  let customerEmail = localStorage.getItem('customerEmail');

  // localStorage에 없으면 DOM에서 가져오기 (fallback)
  if (!customerId || !customerEmail) {
    const customerIdElement = document.querySelector('[data-customer-id]');
    const customerEmailElement = document.querySelector('[data-customer-email]');

    if (customerIdElement) {
      customerId = customerIdElement.getAttribute('data-customer-id');
    }
    if (customerEmailElement) {
      customerEmail = customerEmailElement.getAttribute('data-customer-email');
    }
  }

  // 고객 정보가 없으면 종료
  if (!customerId || !customerEmail || customerId === 'not-found') {
    console.log('🔍 [쿠폰] 비로그인 상태 또는 고객 정보 없음 - 쿠폰 적용 건너뜀');
    return;
  }

  console.log('🔍 [쿠폰] customerId:', customerId, 'customerEmail:', customerEmail);

  localStorage.setItem('shopifyId', customerId);
  localStorage.setItem('customerEmail', customerEmail);

  // 카트 조회
  const cartResponse = await window.CustomApi.getCart();
  const cartData = await cartResponse.json();
  if (!cartData) return;
  const cartId = `gid://shopify/Cart/${cartData.token}`;

  // 멤버쉽 쿠폰 목록 조회
  const response = await window.CustomApi.getMembershipCouponList(customerId, customerEmail);
  const data = await response.json();

  // 추천 쿠폰 계산
  console.log(cartData, data)
  const recommendedCoupon = recommendBestCoupon(cartData, data, new Date(), { units: 'minor' });

  // ✅ Null 체크 추가 - 추천 쿠폰이 없으면 종료
  if (!recommendedCoupon || !recommendedCoupon.code) {
    console.log('[추천 쿠폰] 없음');
    return;
  }

  let couponCode = recommendedCoupon.code;
  console.log('[추천 쿠폰]', recommendedCoupon, couponCode)

  // 수동 사용 쿠폰 체크
  const useCouponCode = sessionStorage.getItem('useCouponCode');
  if (useCouponCode) {
    console.log('[수동 사용 쿠폰]', useCouponCode)

    // 1. 멤버쉽 쿠폰
    if (data.find(item => item.coupon_code === useCouponCode)) {
      couponCode = useCouponCode;
      console.log('[멤버십:수동 사용 쿠폰]', useCouponCode)
    } else {
      // 2. 포인트 쿠폰
      const bonloyaltyResponse = await window.CustomApi.getBonloyaltyCustomer(customerId);
      const bonloyaltyData = await bonloyaltyResponse.json();
      const bonloyaltyCoupon = bonloyaltyData.data?.rewards?.find(item => item.code === useCouponCode);
      
      if (bonloyaltyCoupon && !bonloyaltyCoupon.isUsed) {
        couponCode = useCouponCode;
        console.log('[포인트:수동 사용 쿠폰]', useCouponCode)
      } else {
        sessionStorage.removeItem('useCouponCode');
        console.log('[수동 사용 쿠폰 사용불가 - 존재하지 않거나 이미 사용한 쿠폰]', useCouponCode)
      }
    }
  }

  // 이미 적용된 쿠폰
  if (cartData.discount_codes.find(item => item.code === couponCode)) {
    console.log('[이미 적용된 쿠폰]', couponCode, '이미 적용된 쿠폰')
    return;
  }

  // 3️⃣ 할인 적용 - Ajax Cart API 사용 (더 안정적)
  console.log('🔍 [디버깅] 쿠폰 적용 시도 (Ajax Cart API):', couponCode);

  try {
    // ✅ Ajax Cart API로 쿠폰 적용
    const updateResponse = await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        attributes: {},
        note: '',
        discount: couponCode
      })
    });

    if (!updateResponse.ok) {
      throw new Error(`HTTP error! status: ${updateResponse.status}`);
    }

    const updatedCart = await updateResponse.json();
    console.log('🔍 [디버깅] 장바구니 업데이트 결과:', updatedCart);

    // 쿠폰이 정상 적용되었는지 확인
    const appliedDiscount = updatedCart.discount_codes?.find(d => d.code === couponCode);

    if (!appliedDiscount) {
      console.warn('[쿠폰 적용 실패] 장바구니에 쿠폰이 적용되지 않음:', couponCode);

      // 조건 불충족으로 실패한 경우 sessionStorage 유지
      console.log('[쿠폰 유지] 다음번에 조건 충족 시 재시도');
      return;
    }

    console.log('[할인 자동 적용 성공]', couponCode, updatedCart.discount_codes);
  } catch (error) {
    console.error('❌ [쿠폰 적용 에러]', error);
    return;
  }

  // ✅ 성공 시 sessionStorage에서 제거 (중복 적용 방지)
  sessionStorage.removeItem('useCouponCode');

  // 카트 item key 업데이트
  await refreshCartItemKeysFromCart();
}

async function cartFetchStorefrontApi(query, variables) {
  const response = await fetch(API_ENDPOINT, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': STOREFRONT_ACCESS_TOKEN,
    },
    body: JSON.stringify({ query, variables }),
  });
  const result = await response.json();
  return result.data || {};
}

async function applyDiscountCodes(cartId, discountCodes) {
  const mutation = `
    mutation cartDiscountCodesUpdate($cartId: ID!, $discountCodes: [String!]) {
      cartDiscountCodesUpdate(cartId: $cartId, discountCodes: $discountCodes) {
        cart {
          id
          discountCodes {
            code
            applicable
          }
        }
        userErrors {
          field
          message
          code
        }
      }
    }
  `;
  const variables = { cartId, discountCodes };
  return await cartFetchStorefrontApi(mutation, variables);
}

// 할인 적용 등으로 cart line key가 바뀐 경우, DOM의 key 관련 data-attributes를 최신화
async function refreshCartItemKeysFromCart() {
  const cart = await fetch('/cart.js').then(r => r.json());
  if (!cart || !Array.isArray(cart.items)) return;

  // DOM의 라인 인덱스를 안정적으로 구한다: 우선 순위
  // 1) .cart-item__quantity-input 의 data-line-index
  // 2) li[data-index]
  // 3) 노드 순서 (fallback)
  const lineItems = document.querySelectorAll('li.cart-item');
  lineItems.forEach((li, i) => {
    let idx = NaN;
    const qtyInput = li.querySelector('.cart-item__quantity-input');
    const inputLineIndex = qtyInput && qtyInput.dataset ? qtyInput.dataset.lineIndex : undefined;
    if (inputLineIndex) {
      idx = parseInt(inputLineIndex, 10);
    } else if (li.hasAttribute('data-index')) {
      idx = parseInt(li.getAttribute('data-index'), 10);
    } else {
      idx = i + 1; // fallback: DOM 순서 기반 (1-based)
    }

    if (Number.isNaN(idx)) return;
    const cartItem = cart.items[idx - 1];
    if (!cartItem || !cartItem.key) return;

    // li 자체의 data-key 갱신
    li.setAttribute('data-key', cartItem.key);

    // 체크박스 data-item-key만 동기화 (value/id는 그대로 유지: variant id 기반 로직 보호)
    const checkbox = li.querySelector('input[data-cart-checkbox]');
    if (checkbox) {
      checkbox.setAttribute('data-item-key', cartItem.key);
    }
  });
}
